import get from 'lodash/get'

export default {
  selectedForProductGroup (collection, selectedProductId, productGroupId) {
    let selectedProduct

    if (selectedProductId) {
      selectedProduct = collection.getById(selectedProductId)
    } else {
      // TODO: Select available product first
      const products = collection.getAll({ product_group_id: productGroupId })

      selectedProduct = products.sortBy(
        (product) => product.price_in_cents || product.price_each_in_cents || get(product, 'price.tile.price_in_cents')
      )
      selectedProduct =
        selectedProduct.filter((product) => product.available_quantity > 0).first() || selectedProduct.first()
    }

    return selectedProduct
  }
}
